app.controller("FreshStudentExamsMoveItemController", [
    "$scope", "ExamsManagerService", "$uibModalInstance", "$state", "toastr", "params", "$http", "StudentExamsService",
    function ($scope, ExamsManagerService, $uibModalInstance, $state, toastr, params, $http, StudentExamsService) {
        console.log(params);

        $scope.examItem = params.examItem;

        console.log($scope.examItem._id);

        $scope.chosenSession = null;

        $scope.edit = function () {
            return StudentExamsService.moveExam({
                examItemId: $scope.examItem._id,
                examSessionId: $scope.chosenSession
            })
                .then(function (data) {
                    if (data.status === "success") {
                        toastr.success("გამოცდა გადატანილია");
                        $uibModalInstance.close();
                    } else {
                        toastr.warning("გთხოვთ ცადოთ სხვა სესია");
                    }

                    console.log(data);
                });
        };


        $scope.getSessionsForStudentWithFreeSeats = function () {
            return StudentExamsService.getSessionsWithFreeSeats({examItemId: $scope.examItem._id})
                .then(function (data) {
                    $scope.sessions = data;
                });
        };


        $scope.getSessionsForStudentWithFreeSeats();


        $scope.seatChanged = function () {
            // console.log($scope.chosenSeat);
            // console.log($scope.chosenSession);
            // console.log($scope.chosenSession.examHall.withComputers);
        };


        $scope.close = function () {
            $uibModalInstance.dismiss();
        };

    }
]);
